import clsx from 'clsx';
import React, { useEffect } from 'react';

import { TextButton } from '@components/Button/variants';
import IconError from '@components/Images/Rebranding/IconError';
import { useAppContext } from '@contexts/AppContext';
import { trackBillingErrorCta, trackBillingErrorImpression } from '@tracking/billingError';
import { BillingErrorLike, getCtaConfig, getCtaForCode } from '@utils/billingErrors';

interface BillingErrorProps {
  error: BillingErrorLike;
  className?: string;
  showCta?: boolean;
}

const BillingError = ({ error, className, showCta = true }: BillingErrorProps) => {
  const { initialCurrentUser: currentUser } = useAppContext();
  const resolved = error.cta_type
    ? { cta_type: error.cta_type, cta_link: error.cta_link ?? null }
    : getCtaForCode(error.error_code);
  const { cta_type: ctaType, cta_link: ctaLink } = resolved;

  const ctaConfig = showCta ? getCtaConfig(ctaType) : null;
  const canRenderCta = Boolean(ctaConfig && ctaLink);

  useEffect(() => {
    trackBillingErrorImpression(error, currentUser);
  }, [error, currentUser]);

  return (
    <div
      className={clsx('mt-8 font-suisse-screen text-disclosure-sm text-primary-magenta', className)}
    >
      <div className="flex items-center">
        <IconError className="mr-8 w-[15px] shrink-0" />
        <span>{error.message}</span>
      </div>
      {canRenderCta && (
        <TextButton
          as="link"
          href={ctaLink}
          className="ml-[23px] mt-4 !text-disclosure-sm"
          onClickCapture={() => trackBillingErrorCta(error, ctaType, ctaConfig.label, currentUser)}
        >
          {ctaConfig.label}
        </TextButton>
      )}
    </div>
  );
};

export default BillingError;
